/* eslint-disable no-console */
import axios from 'axios';
import getCookie from '../util/getCookie';

export const getActors = ({
    navigationApiUrl,
    blockId,
    blockName,
    pageType,
    source,
    query,
    username,
    limit,
    offset,
    headers,
    memberUuid,
    sexualOrientation,
}) => {
    const url = `${navigationApiUrl}/dd/v1/actors`;
    const params = {
        blockId,
        blockName,
        pageType,
        source,
        query,
        username,
        limit,
        offset,
        memberUuid,
        sexualOrientation,
    };

    return axios
        .get(url, { headers, params })
        .then(res => res.data)
        .catch(err => {
            console.log(err);
            return [];
        });
};

export const getScenes = ({
    navigationApiUrl,
    blockId,
    blockName,
    pageType,
    source,
    query,
    username,
    limit,
    offset,
    headers,
    memberUuid,
    sexualOrientation,
}) => {
    const url = `${navigationApiUrl}/dd/v1/videos`;
    const params = {
        blockId,
        blockName,
        pageType,
        source,
        query,
        username,
        limit,
        offset,
        memberUuid,
        sexualOrientation,
    };

    return axios
        .get(url, { headers, params })
        .then(res => res.data)
        .catch(err => {
            console.log(err);
            return [];
        });
};

export const getSuggestions = ({
    navigationApiUrl,
    sexualOrientation,
    source,
    query,
    limit,
    offset,
    headers,
}) => {
    const url = `${navigationApiUrl}/dd/v1/suggestions`;
    const params = { sexualOrientation, source, query, limit, offset };

    return axios
        .get(url, { headers, params })
        .then(res => res.data)
        .catch(err => {
            console.log(err);
            return [];
        });
};

export const getSearchData = ({
    blockId,
    blockName,
    pageType,
    navigationApiUrl,
    limit,
    offset,
    query,
    sexualOrientation,
    source,
    referrerHeaders,
    username,
    memberUuid,
}) => {
    const { instance_token, access_token_ma } = getCookie(); // eslint-disable-line camelcase

    const headers = {
        Instance: instance_token,
        Authorization: access_token_ma,
        ...referrerHeaders,
    };

    return Promise.all([
        getActors({
            navigationApiUrl,
            blockId,
            blockName,
            pageType,
            source,
            query,
            username,
            limit,
            offset,
            headers,
            memberUuid,
            sexualOrientation,
        }),
        getScenes({
            navigationApiUrl,
            blockId,
            blockName,
            pageType,
            source,
            query,
            username,
            limit,
            offset,
            headers,
            memberUuid,
            sexualOrientation,
        }),
        getSuggestions({ navigationApiUrl, sexualOrientation, source, query, headers }),
    ]).then(res => ({
        // the "||" is protection against special null response from BE
        actors: res[0].result || [],
        actorsCategories: res[0].meta?.tags || [],
        scenes: res[1].result || [],
        scenesCategories: res[1].meta?.tags || [],
        suggestions: res[2].searchSuggestion || [],
    }));
};
